import { api } from './client';

export interface Pessoa {
  id: number;
  tipo_doc?: 'CPF' | 'CNPJ' | 'EX';
  documento?: string;
  nome?: string;              // NOME DO CAMPO: nome (NAO razao_social)
  nome_fantasia?: string;
  ie?: string;
  im?: string;
  indicador_ie?: number;
  isuf?: string;
  email?: string;
  telefone?: string;
  cep?: string;
  logradouro?: string;
  numero?: string;
  bairro?: string;
  complemento?: string;
  cmun?: string;
  xmun?: string;
  uf?: string;
  cpais?: string;
  xpais?: string;
  ativo?: boolean;
  origem?: string;
}

export async function listPessoas(): Promise<Pessoa[]> {
  const { data } = await api.get<Pessoa[]>('/pessoas');
  return data;
}

export async function getPessoa(id: number): Promise<Pessoa> {
  const { data } = await api.get<Pessoa>(`/pessoas/${id}`);
  return data;
}

export async function createPessoa(payload: Partial<Pessoa>): Promise<Pessoa> {
  const { data } = await api.post<Pessoa>('/pessoas', payload);
  return data;
}

export async function updatePessoa(id: number, payload: Partial<Pessoa>): Promise<Pessoa> {
  const { data } = await api.put<Pessoa>(`/pessoas/${id}`, payload);
  return data;
}

export async function deactivatePessoa(id: number): Promise<void> {
  await api.delete(`/pessoas/${id}`);
}
